import { render, staticRenderFns } from "./NoScrollListView.vue?vue&type=template&id=0073947c&scoped=true&"
import script from "./NoScrollListView.vue?vue&type=script&lang=js&"
export * from "./NoScrollListView.vue?vue&type=script&lang=js&"
import style0 from "./NoScrollListView.vue?vue&type=style&index=0&id=0073947c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0073947c",
  null
  
)

export default component.exports